/** Top-level collection for user documents. */
export const COLLECTION_USER = 'users';
